import React from 'react';
import { Banknote } from 'lucide-react';
import { PAGE } from './copy';
import { OffRampTierLegend } from './OffRampTierLegend';

export function OffRampHero() {
    return (
        <div>
            <h1 className="text-xl font-semibold text-foreground flex items-center gap-2">
                <Banknote className="w-5 h-5 text-primary" /> {PAGE.title}
            </h1>
            <p className="text-sm text-muted-foreground mt-1">{PAGE.subtitle}</p>
            <OffRampTierLegend />
        </div>
    );
}
